(function (angular, app) {
   "use strict";

   angular.module(app.modules.view.name)
      .controller(app.modules.view.routes.register.controller, RegController);
   
  // Injector      
   RegController.$inject = ["$scope", "$window", "$timeout"
       , app.modules.common.constants.appmessaging
       , app.modules.common.services.functions
       , app.modules.ui.services.alerts
   ];
   
   //
   function RegController($scope, $window, $timeout
       , ggMessaging
       , ggFunctions
       , ggAlertSvc
       ) {
      
      $scope.PopupAlert = new ggAlertSvc.popup;
      $scope.InlineAlert = new ggAlertSvc.inline;

      var ctrl = this;
      ctrl.isDirty = false;
      ctrl.isLoaded = true;
      
      ctrl.form = {
         emailAddress: app.Member.Detail.email || ""
         , password: app.Member.Detail.password || ""
         , repassword : null
         , firstName: app.Member.Detail.firstName || ""
         , lastName: app.Member.Detail.lastName || ""
         , postalCode : app.Member.Detail.postalCode || ""
         , agree : 0
         , gender : app.Member.Detail.gender || "Male"
      };
      
      // Password matching
      ctrl.isPasswordMatching = function () {
         var ipm = false;
         if (ctrl.password == ctrl.repassword){
            ipm = true;
         }
         return ipm;
      };
      
      // Send Registration -> Member Service
      ctrl.register = function(isValid){
         ctrl.isDirty = true;
         if (isValid){
            app.Member.Detail.userName     = ctrl.form.emailAddress;
            app.Member.Detail.email        = ctrl.form.emailAddress;
            app.Member.Detail.password     = ctrl.form.password;
            app.Member.Detail.firstName    = ctrl.form.firstName;
            app.Member.Detail.lastName     = ctrl.form.lastName;
            app.Member.Detail.gender       = ctrl.form.gender;
            app.Member.Detail.address = {
                postalCode : ctrl.form.postalCode
            }
            ggFunctions.toggleProcessing(true);
            app.Member.Network.RegisterAccount().then(function (data) {
                if (data && data.status == "201"){
                        return ctrl.login();
                }else{
                   $scope.InlineAlert.fail("", ggMessaging.api.badresponse);
                    ggFunctions.scrollToTop(1);
                }
            }, function (error) {
               $scope.InlineAlert.fail("", error.data.error.message);
                ggFunctions.scrollToTop(1);
            }).finally(function () { ggFunctions.toggleProcessing(false); })
         }else{
            $scope.InlineAlert.fail("", "Please review your registration and complete all the required fields.");
            ggFunctions.scrollToTop(300);
         }
      };

      ctrl.login = function () {
          // Set variables to Member object
          app.Member.Auth.userName = app.Member.Detail.userName;
          app.Member.Auth.password = app.Member.Detail.password;
          return app.Member.Authenticate.Login().then(function (data) {
             if (data && data.status == "200") {

                return app.Member.Authenticate.ValidateToken().then(function (data) {
                   if (app.Member.Auth.isAuthenticated) {
                      $timeout(function () {
                          ggFunctions.goToPage(app.modules.view.routes.intro.path + "?postreg");
                      }, 200);
                   } else {
                      $scope.InlineAlert.fail("Validation Failure", ggMessaging.api.badresponse);
                   }
                });
             } else {
                $scope.InlineAlert.fail("Login Failure", ggMessaging.api.badresponse);
             }
          });
      }
     
   }
}(angular, app));
